import React, { useRef, useState} from "react"
import { useAuth } from "../contexts/AuthContext"
import { Link, useNavigate } from "react-router-dom"
import { Form, Button, Card } from 'react-bootstrap'
import observatory from '../assets/openscope.png'
import { Container } from "mdbreact"



export default function Login(){
    const emailRef = useRef()
    const passRef = useRef()
    const { currentUser, login } = useAuth()  
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)
    const history = useNavigate()

    async function handleSubmit(e) {
        e.preventDefault()
    
        try {
          setError("")
          setLoading(true)
          await login(emailRef.current.value, passRef.current.value)
          history("/about")
        } catch (error){
          console.log(error)
          console.log(currentUser)
          window.alert(error)
          setError("Failed to log in")
        }
        setLoading(false)
    }
    return(
    <>
        <img src={observatory} style={{height:"250px", display:"block", float:"left", marginRight:"auto", marginTop: "30px", paddingRight: "20px"}}></img>
        <div className='container'>
        <Card style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>
            <Card.Body style={{justifyContent:'center', alignItems:'center'}}>
            <Card.Title style={{display: 'flex',  justifyContent:'center', alignItems:'center',  border: '1px solid #e5e5e5'}}>Log In</Card.Title>
                <Form onSubmit={handleSubmit} >
                    <Form.Group className="mb-3" controlId="formBasicEmail"  style = {{border: '1px solid #e5e5e5'}}>
                        <Form.Label style={{margin:"15px"}}>Email address</Form.Label>
                        <Form.Control type="email" placeholder="Enter email" ref={emailRef} />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicPassword" style = {{border: '1px solid #e5e5e5'}}>
                        <Form.Label style={{margin:"15px"}}>Password</Form.Label>
                        <Form.Control type="password" placeholder="Password" ref={passRef} />
                        <Button variant="primary" type="submit" style={{marginLeft:"80px"}}>
                        Submit
                        </Button>
                    </Form.Group>

                </Form>
            </Card.Body>
        </Card>
        </div>
        </>
    )
}